__webpack_require__.p = "https://images-cdn-staging.curipod.com/pr-61930571/_next/";